import { Erod, EraQL } from '@cotera/era';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Schema = Erod.Def<any>;

function emptyBaseValue(schema: Schema): unknown {
  const ty = schema.ty.ty;
  if (ty.k === 'enum') {
    return ty.t[0] ?? '';
  }
  if (ty.k === 'primitive') {
    switch (ty.t) {
      case 'boolean':
        return false;
      case 'int':
      case 'float':
        return 0;
      default:
        return '';
    }
  }
  return null;
}

function jsonTemplateOfSchema(schema: Schema): unknown {
  const shape = schema.shape;
  switch (shape.t) {
    case 'lazy':
      return jsonTemplateOfSchema(shape.get());
    case 'discriminatedUnion': {
      const first = shape.options[0];
      return first !== undefined ? jsonTemplateOfSchema(first) : {};
    }
    case 'struct': {
      const out: Record<string, unknown> = {};
      for (const [name, fieldSchema] of Object.entries(shape.fieldsSchema)) {
        out[name] = jsonTemplateOfSchema(fieldSchema);
      }
      return out;
    }
    case 'array':
      // One representative element so path pickers can drill into item fields
      // (empty [] hides nested structure in the upstream variable menu).
      return [jsonTemplateOfSchema(shape.elementSchema)];
    case 'base':
      return emptyBaseValue(schema);
    default:
      return {};
  }
}

/**
 * Builds a representative JSON sample from an ERAQL output shape string.
 * Used for param-binding path suggestions in the workflow editor.
 */
export function sampleJsonFromOutputShape(
  outputShape: string | null | undefined
): unknown | null {
  if (outputShape === null || outputShape === undefined || outputShape === '') {
    return null;
  }
  let parsed;
  try {
    parsed = EraQL.parseTy(outputShape);
  } catch {
    return null;
  }
  if (parsed.isErr()) {
    return null;
  }
  // Best-effort: an unsupported type in the shape should degrade to "no sample"
  // rather than crash the workflow editor that renders it.
  try {
    const schema = Erod.Schema.bareSchemaFromTy(parsed.value);
    return jsonTemplateOfSchema(schema);
  } catch {
    return null;
  }
}
